import React, { useCallback } from 'react';
// @ts-ignore — react-dropzone v3 has incompatible TS types
import Dropzone from 'react-dropzone';
import LegacyButton from '../../../shared/button';

const trackDropZoneStyle: React.CSSProperties = {
  display: 'inline-block',
  padding: 0,
  cursor: 'pointer',
  width: '100%',
  marginBottom: 12,
};

export interface TrackUploadDropzoneProps {
  mediaID: string;
  uploadTrack: (mediaID: string, file: File, progress: (...args: unknown[]) => void) => Promise<unknown>;
}

const TrackUploadDropzone: React.FC<TrackUploadDropzoneProps> = ({ mediaID, uploadTrack }) => {
  const ignoreTrackUploadProgress = useCallback(() => {}, []);

  const handleTrackDrop = useCallback((files: File[]) => {
    if (!files[0]) return;

    const file = files[0];

    try {
      Promise.resolve(uploadTrack(mediaID, file, ignoreTrackUploadProgress))
        .catch((ex: unknown) => {
          console.error('Track upload failed', {
            message: 'Track upload failed',
            context: { mediaID, fileName: file.name },
            error: ex,
          });
        });
    } catch (ex: unknown) {
      console.error('Track upload failed', {
        message: 'Track upload failed',
        context: { mediaID, fileName: file.name },
        error: ex,
      });
    }
  }, [ignoreTrackUploadProgress, mediaID, uploadTrack]);

  return (
    // @ts-ignore — react-dropzone v3 API
    <Dropzone
      onDrop={handleTrackDrop}
      disablePreview
      multiple={false}
      accept="application/json"
      style={trackDropZoneStyle}
    >
      <LegacyButton
        affirm
        small
      >
        Select Track File
      </LegacyButton>
    </Dropzone>
  );
};

export default TrackUploadDropzone;
